import { render, staticRenderFns } from "./VSidebar.vue?vue&type=template&id=3cfa108c"
import script from "./VSidebar.vue?vue&type=script&lang=js"
export * from "./VSidebar.vue?vue&type=script&lang=js"
import style0 from "./VSidebar.vue?vue&type=style&index=0&id=3cfa108c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports